export default {

  template: /* html */`
  <svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    width="100"
    height="100"
    viewBox="0 0 26.458333 26.458333"
    version="1.1"
    id="svg2707"
    inkscape:version="0.92.5 (2060ec1f9f, 2020-04-08)"
    sodipodi:docname="triangle.svg">
    <defs
      id="defs2701" />
    <sodipodi:namedview
      id="base"
      pagecolor="#ffffff"
      bordercolor="#666666"
      borderopacity="1.0"
      inkscape:pageopacity="0.0"
      inkscape:pageshadow="2"
      inkscape:zoom="3.6896455"
      inkscape:cx="120.88965"
      inkscape:cy="63.345773"
      inkscape:document-units="px"
      inkscape:current-layer="layer1"
      showgrid="false"
      units="px"
      inkscape:window-width="1920"
      inkscape:window-height="987"
      inkscape:window-x="0"
      inkscape:window-y="0"
      inkscape:window-maximized="1" />
    <metadata
      id="metadata2704">
      <rdf:RDF>
        <cc:Work
          rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type
            rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
          <dc:title></dc:title>
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <g
      inkscape:label="Layer 1"
      inkscape:groupmode="layer"
      id="layer1"
      transform="translate(0,-270.54167)">
      <path
        d="M 23.8125,289.06249 13.229173,278.47917 2.645833,289.06251"
        id="path915"
        inkscape:connector-curvature="0"
        sodipodi:nodetypes="ccc"
        inkscape:transform-center-x="0.14183327"
        inkscape:transform-center-y="-1.0095895" />
    </g>
  </svg>
  `
}